/*
 * PopupSlider module.
 */

/**
 * InfoSlider popup extension for PinMap
 * @param {[type]} $pinmap [description]
 */
var PopupSlider = function ($element) {
  // Must provide an existing PinMap element for
  // adding required DOM controls
  if (!$element.length) {
    return false;
  }

  // Create InfoSlider element if not already existing
  this.$element = $element.find('.popup-slider');
  this.$content = this.$element.find('.content');
  this.$close_button = this.$element.find('.btn-close');
  this.closed = null;
  if (!this.$element.length) {
    this.$element = $('<div class="popup-slider"></div>');
    this.$content = $('<div class="content"></div>').appendTo(this.$element);
    $element.append(this.$element);
  }
  return this;
};
PopupSlider.prototype.setContent = function (content) {
  this.$content.html(content);
  this.$close_button = this.$content.find('.btn-close');
};
PopupSlider.prototype.getContent = function () {
  return this.$element.html();
};
PopupSlider.prototype.open = function () {
  var that = this;
  this.$element.addClass('state-active');
  // Apply close functionality
  this.$close_button.on('click', function () {
    that.close();
  });
};
PopupSlider.prototype.close = function () {
  this.$content.html('');
  this.$element.removeClass('state-active');
  if (this.closed) {
    this.closed();
  }
};
export default PopupSlider;